import { AgentProfileModal } from "@/react/components/AgentProfileModal";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";

// import "./styles.scss";

export interface AgentProfileDrawerProps {
  agentId: number;
  params?: {
    shouldOpenInNewTab?: boolean;
  };
}

const AgentProfileDrawer = ModalManager.create(
  ({ agentId, params }: AgentProfileDrawerProps) => (
    <AgentProfileModal agentId={agentId} params={params} />
  ),
);

export const useAgentProfileDrawer = () => useModal(AgentProfileDrawer);
